import React, { useEffect, useRef, useState } from 'react'
import "../styles/forumPage.css";
import ForumPost from '../components/ForumPost';
import BeatLoader from 'react-spinners/BeatLoader';

export default function ForumPage({ addToast }) {
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState("");
    const [selectedContent, setSelectedContent] = useState("all")
    const [images, setImages] = useState([]);

    const [posts, setPosts] = useState([]);

    // const testImages = [
    //     "https://ugytudjuk.hu/storage/userfiles/c/1/c1efe53eb9c00f098ba995d04689f098.jpg",
    //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCk11IVEYV4RxC-D398PpyisV9Yz9Xl3IFUQ&s"
    // ]
    // const testComments = [
    //     {
    //         "id": 1,
    //         "text": "Fő komment",
    //         "username": "Zsolt",
    //         "parent_comment_id": null
    //     },
    //     {
    //         "id": 3,
    //         "text": "Fő komment 2",
    //         "username": "Zsolt",
    //         "parent_comment_id": null
    //     },
    //     {
    //         "id": 2,
    //         "text": "Válasz komment",
    //         "username": "Anna",
    //         "parent_comment_id": 1
    //     },
    //     {
    //         "id": 4,
    //         "text": "Válasz komment 2",
    //         "username": "Anna",
    //         "parent_comment_id": 1
    //     },
    //     {
    //         "id": 5,
    //         "text": "Válasz komment 3",
    //         "username": "Anna",
    //         "parent_comment_id": 1
    //     }
    // ]


    // POSZTOK LEKÉRÉSE

    useEffect(() => {
        let url = "https://focifanatik.hu/api/forumPage/forumPosts.php";
        if (selectedContent === "all") url = "https://focifanatik.hu/api/forumPage/forumPosts.php";
        else if (selectedContent === "todays") url = "https://focifanatik.hu/api/forumPage/forumPostsToday.php";
        else if (selectedContent === "followed") url = "https://focifanatik.hu/api/forumPage/forumPostsFollowed.php";

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setPosts(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));

    }, [selectedContent])

    // POSZT FELTÖLTÉSE
    const handleSubmit = async () => {
        if (loading) return;
        if (!text.trim() && images.length === 0) {
            addToast("Nem lehet üres posztot küldeni!", "warning");
            setLoading(false);
            return;
        }
        setLoading(true);

        const formData = new FormData();
        formData.append("text", text);

        images.forEach(img => {
            formData.append("images[]", img.file);
        });

        try {
            const res = await fetch("https://focifanatik.hu/api/forumPage/uploadPost.php", {
                method: "POST",
                body: formData,
                credentials: "include"
            });

            const data = await res.json();

            if (data.success) {
                addToast("Sikeres feltöltés!", "success");
                setImages([]);
                setText("");
            } else {
                addToast("Hiba történt", "warning");
            }

        } catch (err) {
            addToast("Szerver hiba!", "warning");
        }
        setLoading(false);
    }

    const fileInputRef = useRef();

    return (
        <div className='forumPage'>
            <div className='forumPage-topBar'>
                <input type="text" placeholder='Ird be a nevet amire rá akarsz keresni...' />
                <button
                    className={selectedContent === "all" ? "active" : ""}
                    onClick={() => setSelectedContent("all")}
                >
                    Összes
                </button>
                <button
                    className={selectedContent === "todays" ? "active" : ""}
                    onClick={() => setSelectedContent("todays")}
                >
                    Mai napi
                </button>
                <button
                    className={selectedContent === "followed" ? "active" : ""}
                    onClick={() => setSelectedContent("followed")}
                >
                    Követett
                </button>
            </div>

            <div className='forumPage-newPost'>
                <div className='forumPage-newPost-topText'>
                    <span>Oszd meg a szelvényedet</span>
                </div>


                <div className='forumPage-newPost-inputs'>
                    <textarea type="text" placeholder='Ird ide a gondolataid...' value={text} onChange={(e) => setText(e.target.value)} />
                    <label className='fileUpload'>
                        <input
                            type="file"
                            accept='image/*'
                            ref={fileInputRef}
                            multiple
                            onChange={(e) => {
                                const files = Array.from(e.target.files);

                                const imageUrls = files.map(file => ({
                                    file,
                                    url: URL.createObjectURL(file)
                                }));

                                setImages(prev => {
                                    const existingNames = prev.map(img => img.file.name);

                                    let hasDuplicate = false;

                                    const filtered = imageUrls.filter(img => {
                                        const isDuplicate = existingNames.includes(img.file.name);

                                        if (isDuplicate) {
                                            hasDuplicate = true;
                                        }

                                        return !isDuplicate;
                                    });

                                    if (hasDuplicate) {
                                        addToast("Ezt a képet már feltöltötted!", "warning");
                                    }

                                    return [...prev, ...filtered];
                                });

                                e.target.value = null;
                            }}
                        />
                        <span>Kép feltöltése</span>
                    </label>
                </div>

                {images.length > 0 && (
                    <div className='imagePreview'>
                        {images.map((img, index) => (
                            <div key={index} className="imageItem">
                                <img src={img.url} alt="preview" />
                                <button onClick={() => {
                                    setImages(prev => prev.filter((_, i) => i !== index));

                                    if (fileInputRef.current) {
                                        fileInputRef.current.value = null;
                                    }
                                }}>
                                    <i class="bi bi-x-circle"></i>
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                <div className='forumPage-newPost-submitBtn'>
                    <button onClick={handleSubmit}>
                        {loading ? <div className='loadingBeatLoaderForumPage'><BeatLoader color="white" speedMultiplier={2} size={32} /></div> : "Megosztás"}
                    </button>
                </div>

            </div>


            {/* -------------------------------------------------- POSZTOK ----------------------------------------- */}
            <div className='forumPage-content'>

                {posts && posts.map((post) => (
                    <ForumPost
                        id={post.id}
                        name={post.username}
                        profile_picture={post.profile_picture}
                        timeAgo={post.timeAgo}
                        text={post.text}
                        images={post.images}
                        isLiked={post.isLiked}
                        likes={post.like_count}
                        commentsCount={post.comments.length}
                        comments={post.comments} />
                ))}




            </div>


        </div>
    )
}
